import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_review_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_name: fromDatatype.VarcharDatatypeInterface;
  reviewer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reviewer_name: fromDatatype.VarcharDatatypeInterface;
  review_remarks: fromDatatype.TextDatatypeInterface;
  review_status: fromDatatype.VarcharDatatypeInterface;
  review_date: fromDatatype.TimestampTzDatatypeInterface;
  date_added_to_claim_cycle: fromDatatype.TimestampTzDatatypeInterface;
  ip_address: fromDatatype.VarcharDatatypeInterface;
  esignature: fromDatatype.VarcharDatatypeInterface;
  cookies: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_review_history_RowClass implements bl_aat_claim_cycle_review_history_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  claimant_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claimant_name: fromDatatype.VarcharDatatypeInterface;
  reviewer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reviewer_name: fromDatatype.VarcharDatatypeInterface;
  review_remarks: fromDatatype.TextDatatypeInterface;
  review_status: fromDatatype.VarcharDatatypeInterface;
  review_date: fromDatatype.TimestampTzDatatypeInterface;
  date_added_to_claim_cycle: fromDatatype.TimestampTzDatatypeInterface;
  ip_address: fromDatatype.VarcharDatatypeInterface;
  esignature: fromDatatype.VarcharDatatypeInterface;
  cookies: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
